export class LmCustomerSettings {
    accessorialReport: boolean;
    boLsInLoadDocuments: boolean;
    checkCallTimes: boolean;
    customerRateConfirmations: boolean;
    loadDetailReport: boolean;
    rateOnTenderLoad: boolean;
    reeferTemperatures: boolean;
    showCheckedInStatus: boolean;
    showPreLoadedCheckCalls: boolean;
}